import { observer } from 'mobx-react-lite';
import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import ButtonBase from '../ButtonBase';
import InputBase from '../InputBase';
import Modal from '../Modal';

const Transcript = () => {
  const {
    fontFamily,
    transcript: { color, cancelBtn, submitBtn }
  } = useConfig();
  const { ui } = useStores();
  const emailInputRef = useRef(null);
  const { t } = useTranslation();

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault();
      const email = emailInputRef.current.value;

      if (email) {
        // await sendTranscript({ email: emailInputRef.current.value });
        ui.setOpenTranscript(false);
      }
    },
    [ui]
  );

  return (
    <Modal isOpen={ui.isOpenedTranscript}>
      <Form onSubmit={handleSubmit} textFontFamily={fontFamily}>
        <Label textColor={color}>{t('enterEmailAddress')}</Label>
        <Input
          ref={emailInputRef}
          type="email"
          name="email"
          placeholder={t('emailAddress')}
          required
          baseColor={color}
        />
        <Controls>
          <ButtonClose
            type="button"
            onClick={() => ui.setOpenTranscript(false)}
            textColor={cancelBtn.color}
            background={cancelBtn.background}
          >
            <span>&#10006;</span>
            {t('cancel')}
          </ButtonClose>
          <ButtonSubmit
            type="submit"
            // disabled={isLoading}
            textColor={submitBtn.color}
            background={submitBtn.background}
          >
            {t('enter')}
          </ButtonSubmit>
        </Controls>
      </Form>
    </Modal>
  );
};

const Form = styled.form`
  width: 100%;
  max-width: 510px;
  height: auto;
  padding: 30px;
  margin: 0 20px;
  font-family: ${props => props.textFontFamily};
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.2);
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  color: ${props => props.textColor};
`;

const Input = styled(InputBase)`
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  font-family: inherit;
  color: ${props => props.baseColor};
  border: 1px solid ${props => props.baseColor};
  border-radius: 2px;

  label {
    padding: 0;
  }

  input::placeholder {
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 19px;
    color: ${props => props.baseColor};
    opacity: 0.5;
  }
`;

const Controls = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  ${ButtonBase} {
    padding: 8px 12px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    border-radius: 2px;
    span {
      display: inline-block;
      margin-right: 2px;
      font-size: 12px;
    }
  }
`;

const ButtonClose = styled(ButtonBase)`
  margin-right: 4px;
  color: ${props => props.textColor};
  background-color: ${props => props.background};
`;

const ButtonSubmit = styled(ButtonBase)`
  color: ${props => props.textColor};
  background-color: ${props => props.background};
`;

export default observer(Transcript);
